import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import Navbar from "../Home/NavBar/Navbar";
import { useNavigate } from "react-router-dom";
import WhyChooseQuikTix from "../Home/WhyChooseTix/WhyQuickTix";
import AffordablePricing from "../Home/AffordablePricing/AffordablePricing";
import TestimonialsPage from "../Home/Testimonials/Testimonials";
import Footer from "../Home/Footer/Footer";

const AboutUs = () => {
  const navigate = useNavigate();


  useEffect(() => {
    // Scroll to top when the page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Box
        sx={{
          paddingLeft: "25px",
          paddingRight: "25px",
          boxShadow: "0 1px 5px rgba(0,0,0,0.1)",
        }}
      >
        <Navbar />
      </Box>

      <Box sx={{ mt: 4, mb: { xs: 2, md: 15 }, position: "relative" }}>
        <Container maxWidth="lg" sx={{ zIndex: 1 }}>
          <Grid
            container
            spacing={4}
            alignItems="center"
            justifyContent="center"
          >
            <Grid
              item
              xs={12}
              md={8}
              sx={{ minHeight: { xs: "auto", md: 340 } }}
            >
              <Box
                sx={{ marginTop: { xs: 3, md: 10 }, marginRight: { md: 5 } }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontSize: { xs: 24, sm: 32, md: 48 } }}
                  fontWeight={700}
                  gutterBottom
                >
                  About us
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ textAlign: {xs: "left", md: "justify"}, hyphens: "auto" }}
                >
                  Welcome to GX Tickets, your go-to platform for seamless event
                  management and hassle-free ticket booking. We connect
                  organizers with audiences, making event creation, promotion,
                  and management effortless.{" "}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={8} md={4}>
              <Box
                sx={{
                  display: { xs: "none", md: "block" },
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: { md: "25%", lg: "30%" },
                  pt: 1,
                  height: "100%",
                  backgroundColor: "black",
                  zIndex: 0,
                  overflow: "hidden",
                }}
              >
                <svg
                  width="411"
                  height="425"
                  viewBox="0 0 411 425"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M72.564 31.039C77.0667 14.2349 94.3393 4.26251 111.143 8.76517L321.641 65.1679C338.446 69.6706 348.418 86.9432 343.915 103.747L280.116 341.851C275.613 358.655 258.34 368.628 241.536 364.125L31.0382 307.722C14.234 303.219 4.26171 285.947 8.76437 269.143L72.564 31.039Z"
                    stroke="white"
                  />
                  <path
                    d="M225.066 104.477C237.367 92.1758 257.312 92.1758 269.614 104.477L387.497 222.361C399.799 234.662 399.799 254.607 387.497 266.909L253.076 401.33C240.774 413.632 220.83 413.632 208.528 401.33L90.6445 283.447C78.343 271.145 78.343 251.2 90.6445 238.899L225.066 104.477Z"
                    stroke="white"
                  />
                </svg>
              </Box>
              <Box
                sx={{
                  backgroundColor: "#fff",
                  padding: { xs: "1.5rem", md: "2rem" },
                  borderRadius: "8px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                  position: "relative",
                  zIndex: 1,
                  mb: { xs: 3, md: -25 },
                }}
              >
                <Typography variant="h5" fontWeight={700} gutterBottom>
                  Our Mission
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  gutterBottom
                  sx={{ textAlign: {xs: "left", md: "justify"}, hyphens: "auto" }}
                >
                  Our mission is simple: to revolutionize the event management
                  and ticketing industry with innovative solutions that simplify
                  the process and enhance the user experience. We aim to empower
                  organizers and attendees alike, ensuring that every event,
                  from small gatherings to large-scale concerts, is a success.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box sx={{ mt: { xs: 10, md: 20 } }}>
        <WhyChooseQuikTix />
      </Box>

      <Box sx={{ mt: { xs: 10, md: 20 } }}>
        <AffordablePricing />
      </Box>

      <Box sx={{ mt: { xs: 10, md: 20 } }}>
        <TestimonialsPage />
      </Box>

      <Box sx={{ mt: { xs: 20, md: 20 } }}>
        <Footer />
      </Box>
    </>
  );
};

export default AboutUs;
